import {
  BUSSINESS,
  BUSSINESS_SUBJECTS,
  SENSITIVE_WORDS,
  SUBJECTS,
  USER_GROUPS,
  USER_NAME
} from '../../service/constant'

const mutations = {
  setAuthInfo(state: any, payload: any) {
    state[USER_NAME] = payload[USER_NAME]
    state[USER_GROUPS] = payload[USER_GROUPS]
  },
  clearAuthInfo(state) {
    state[USER_NAME] = ''
    state[USER_GROUPS] = []
  },
  setConstants(state, payload: any) {
    state[SENSITIVE_WORDS] = payload[SENSITIVE_WORDS]
    state[BUSSINESS] = payload[BUSSINESS]
    state[SUBJECTS] = payload[SUBJECTS]
    state[BUSSINESS_SUBJECTS] = payload[BUSSINESS_SUBJECTS]
  }
}

export default mutations
